export const LOGO_LINK = "https://review.kamkombank.ru/";